import { render, staticRenderFns } from "./InterrelationsPanel.vue?vue&type=template&id=f59848ec&"
import script from "./InterrelationsPanel.vue?vue&type=script&lang=js&"
export * from "./InterrelationsPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports